// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3LSNT","type":"styles_type__1vPhq","choices":"styles_choices__2LCCO"};